import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { register } from 'swiper/element/bundle';
import { CardModule } from '@components/card/card.component';
register();

@Component({
	selector: 'app-blog-related',
	templateUrl: './blog-related.component.html',
	styleUrls: ['./blog-related.component.scss'],
})
export class BlogRelatedComponent {
	@Input() related: any;
}

/*================================================================
# MODULE
================================================================*/
@NgModule({
	declarations: [BlogRelatedComponent],
	exports: [BlogRelatedComponent],
	imports: [CommonModule, TranslateModule, CardModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BlogRelatedModule {}
